export enum SnackbarStatus {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Default = 'default',
}

export enum SnackbarPosition {
  TopRight = 'top-right',
  TopLeft = 'top-left',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
  MiddleMiddle = 'middle-middle',
  TopMiddle = 'top-middle',
  LeftMiddle = 'left-middle',
  RightMiddle = 'right-middle',
  BottomMiddle = 'bottom-middle',
}
